import { Td, Tr, Text } from "@chakra-ui/react";
import React from "react";
import Switch from "../Switch/Switch";
import { useUpdateCYAvailability } from "../../api/CodeYellowAvailabilityApi";
import { CodeYellowTargetedProvidersWithAvailabilityResponse } from "../../api/CodeYellowApi";
import { useUserData } from "../../api/UserApi";

interface Props {
  provider: CodeYellowTargetedProvidersWithAvailabilityResponse["targetedProviders"][number];
}

const TargetedProvider: React.FC<Props> = ({ provider }) => {
  return provider.name;
};

const TargetedProviderOptInOut: React.FC<Props & { codeYellowId: string | null, showSwitch?: boolean }> = ({
  provider,
  codeYellowId,
  showSwitch = true
}) => {
  const { data: currentUser } = useUserData();
  const { mutate } = useUpdateCYAvailability();

  const handleChangeAvailability = () => {
    mutate({
      codeYellowId: codeYellowId!,
      userId: provider.id,
      optIn: !provider.availability,
    });
  };

  const isCurrentUser = currentUser?.id === provider.id;
  const canChangeStatus = isCurrentUser || provider.canOptOut;

  if (!canChangeStatus && !showSwitch) {
    return null;
  }

  return (
    <Switch
      isToggled={provider.availability}
      onToggle={handleChangeAvailability}
      disabled={!canChangeStatus}
    />
  );
};

const TargetedProvidersRow: React.FC<Props & { codeYellowId: string | null, showSwitch?: boolean }> = ({
  provider,
  codeYellowId,
  showSwitch = true
}) => {
  return (
    <Tr>
      <Td>
        <Text color="white">
          <TargetedProvider provider={provider} key={provider.id} />
        </Text>
      </Td>
      <Td textAlign="right">
        <TargetedProviderOptInOut provider={provider} codeYellowId={codeYellowId} showSwitch={showSwitch} />
      </Td>
    </Tr>
  );
};

export default TargetedProvidersRow;
